<div class="new-password-container">
  @if (resetPasswordToken && resetPasswordHash) {
    @if (resetPasswordForm) {
      <form
        (ngSubmit)="resetPassword()"
        [formGroup]="resetPasswordForm"
        novalidate
      >
        <div class="new-password-card">
          <div class="stack s-6">
            @if (message) {
              <p class="m-0 text-center title-medium">
                {{ 'password_reset_success_message' | translate }}
              </p>
            }

            @if (!message) {
              <p class="m-0 text-center title-medium">
                {{ 'password_reset_enter_new_password_message' | translate }}
              </p>

              <div class="new-password-card__form-fields">
                <mat-form-field>
                  <mat-label>{{ 'New_password' | translate }}</mat-label>
                  <input
                    matInput
                    [placeholder]="'New_password' | translate"
                    formControlName="password"
                    type="password"
                    required
                  />
                  <!-- @if (loginForm.controls['password'].invalid &&
                  loginForm.controls['password'].touched) { -->
                  <mat-error>
                    {{ 'password_entry_required' | translate }}
                  </mat-error>
                  <!-- } -->
                </mat-form-field>

                <mat-form-field>
                  <mat-label>{{ 'Repeat_new_password' | translate }}</mat-label>
                  <input
                    matInput
                    [placeholder]="'Repeat_new_password' | translate"
                    formControlName="repeat_password"
                    type="password"
                    required
                  />
                  <!-- @if (loginForm.controls['password'].invalid &&
                  loginForm.controls['password'].touched) { -->
                  <mat-error>
                    {{ 'Repeated_password_entry_required' | translate }}
                  </mat-error>
                  <!-- } -->
                </mat-form-field>

                @if (password_change_hint) {
                  <div class="error-message">
                    {{ password_change_hint }}
                  </div>
                }
              </div>
            }
            <div class="new-password-card__actions">
              @if (!message) {
                <button
                  mat-button
                  type="submit"
                  [disabled]="
                    resetPasswordForm.value.password !==
                      resetPasswordForm.value.repeat_password ||
                    resetPasswordForm.invalid
                  "
                >
                  <span>{{ 'reset_password' | translate }}</span>
                </button>
              }

              @if (message) {
                <button mat-button type="button" (click)="backToLogin()">
                  <span>{{ 'Back_to_login' | translate }}</span>
                </button>
              }
            </div>
          </div>
        </div>
      </form>
    }
  }
</div>
